var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';

import { connect } from 'react-redux';
import { Translate } from "../../I18N";


import { ActivitylogRow } from "./ActivitylogRow";

const mapStateToProps = ({
  activitylog


}) => ({
  list: activitylog.list
});

const connector = connect(mapStateToProps);


const ActivityLogListComponent = ({ list }) => /*#__PURE__*/
_jsx("div", { className: "activity-log-list" }, void 0, /*#__PURE__*/
_jsx("table", { className: "table" }, void 0, /*#__PURE__*/
_jsx("thead", {}, void 0, /*#__PURE__*/
_jsx("tr", {}, void 0, /*#__PURE__*/
_jsx("th", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Action")
), /*#__PURE__*/
_jsx("th", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "User")
), /*#__PURE__*/
_jsx("th", { className: "activitylog-description" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Description")
), /*#__PURE__*/
_jsx("th", { className: "activitylog-time" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Time")
)
)
), /*#__PURE__*/
_jsx("tbody", {}, void 0,
list.map((entry) => /*#__PURE__*/
_jsx(ActivitylogRow, { entry: entry }, entry.get('_id').toString())
)
)
)
);


const container = connector(ActivityLogListComponent);
export { container as ActivitylogList, mapStateToProps };